
import $ from "jquery";
import React, { useEffect, useState } from 'react';
import { Badge, Button, Col, Container, Form, Row, Table } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import AsyncSelect from 'react-select/async';
import "../../../mcss/main.css";
import ActivityLog from '../../ActivityLog';
import * as Common from "../../Common";
import Dialog from '../../Dialog';
import DialogYesNo from '../../Dialog_Yes_No';
import LoginHeader from '../../Login_header';
import Menu from '../../Menu';
import * as Picklist from "../../Picklist";

function SpPpModification() {
    const navigate = useNavigate();
    const sid = sessionStorage.getItem("sessionId");
    const userSrno = sessionStorage.getItem("userSrno");

    const [filtertransaction, setFiltertransaction] = useState('');
    const [headerList, setHeaderList] = useState([]);
    const [ppLocationValue, setPPLocationValue] = useState(0);
    const [tranAuditTrail, setTranAuditTrail] = useState([]);
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");
    const [ppLocation, setPPLocation] = useState(null);
    const [userRight, setUserRight] = useState([]);

    const [hdrLocation, setHdrLocation] = useState("");
    const [filterSrno, setFilterSrno] = useState("");
    const [editbtnView, setEditbtnView] = useState(true);
    const [isSaveDialogOpen, setSaveDialogOpen] = useState(false);
    const [saveMsgTextYN, setSaveMsgTextYN] = useState("Are you sure you want to save?");
    const [showActivityLog, setShowActivityLog] = useState(false);
    const [logObject, setLogObject] = useState({ trantype: "", trannumber: "", trancategory: "" });
    const [compareData, setCompareData] = useState([]);
    // const [headerList, setHeaderList] = useState([]);
    const [editbtnHeaderView, setEditbtnHeaderView] = useState(true);
    const [individual, setIndividual] = useState([]);
    const [executiveCode, setIndividualCode] = useState(0);
    const [saveData, setSaveData] = useState(null);
    const [purpose, setPurpose] = useState(null);
    const [purposeCode, setPurposeCode] = useState(0);
    const [cardno, setCardno] = useState('')
    const [radioType, setRadioType] = useState('');
    const [compareObj, setCompareObj] = useState(null);

    const [showFilter, setShowFilter] = useState(true);
    const [isdCode, setIsdCode] = useState('');
    const [scrMode, setScrMode] = useState('')

    useEffect(() => {
        Common.getActiveBranch().then(response => {
            setPPLocation(response);
            response != null && handleLocationChange(response);
        });

        Common.callApi(Common.apiRight, [sid, 'all', 'SP_PP_MODIFICATION'], function (result) {
            let resp = JSON.parse(result);
            if (resp.query === "1") {
                setUserRight(resp);
            } else {
                navigate('/'); // no query right
            }
        });
    }, []);
    const handleLocationChange = (value) => {
        setPPLocation(value);
        var id = value.id;
        var location = id.split("^");
        setPPLocationValue(location[1]);
        setHdrLocation(location[2]);
        setHeaderList([]);
        setEditbtnHeaderView(true)
        sessionStorage.activeBranch = location[1];
    }

    const applyFilter = () => {
        $(".loader").show();
        var msg = [], i = 0;
        msg[i++] = Common.getMessage("MSG0006");
        !ppLocationValue && (msg[i++] = 'Location.')
        !filtertransaction && (msg[i++] = 'Transaction.')
        !radioType && (msg[i++] = 'Modification.')
        !filterSrno && (msg[i++] = 'Srno .')
        if (i > 1) {
            $(".loader").hide();
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            var obj = {
                location: ppLocationValue,
                transaction: filtertransaction,
                filterSrno: filterSrno,
                modificationType: radioType,
            }
            Common.callApi(Common.apiPpSpModification, [sid, "getlist", JSON.stringify(obj)], function (result) {
                $(".loader").hide();
                let resp = JSON.parse(result);
                if (resp.status) {
                    if (resp.list.length > 0) {
                        setScrMode('L');
                        setHeaderList(resp.list);
                        setIndividual([])
                        setIndividualCode(0);
                    } else {
                        setScrMode('L');
                        setHeaderList([]);
                        setMsgText("Data Not Found");
                        setMsgBox(true);
                    }
                } else {
                    setHeaderList([]);
                    setMsgText(resp.msg);
                    setMsgBox(true);
                }
                setEditbtnHeaderView(true);
            })
        }

    }

    // const fillViewFormSp = (obj) => {
    //     const obj = {
    //         srno: obj.hdr_srno,
    //         spLocationValue: obj.hdr_location,
    //         type: "SP"
    //     }
    //     Common.callApi(Common.apiTranSP, [sid, "viewdata", JSON.stringify(obj)], result => {
    //         let resp = JSON.parse(result);
    //         if (resp.msg === "MSG0000") {
    //             const obj = {
    //                 srno: hdrSrno,
    //                 spLocationValue: spLocationValue,
    //                 spSaleType: spSaleType,
    //                 spNewDate: hdrSrno < 1 ? Common.dateYMD(spNewDate) : hdrDateYmd,
    //                 nCorporate: nCorporate,
    //                 nCountry: nCountry,
    //                 nState: nState.value,
    //                 nResident: nResident,
    //                 nTraveller: nTraveller,
    //                 nPurpose: nPurpose,
    //                 nEncashmentNumber: nEncashmentNumber,
    //                 nEncashmentFrom: nEncashmentFrom,
    //                 nEncashmentDate: nEncashmentDate,
    //                 nExecutive: nExecutive,
    //                 pForexTotal: pForexTotal,
    //                 nFlightNo: nFlightNo,
    //                 nTicketNo: nTicketNo,
    //                 nVisaType: nVisaType,
    //                 nDepDate: Common.dateYMD(nDepDate),
    //                 nTicketClass: nTicketClass,
    //                 nDuration: nDuration,
    //                 nPanForm60: nPanForm60,
    //                 nMode: nMode,
    //                 pSgst: pSgst,
    //                 pIgst: pIgst,
    //                 pUgst: pUgst,
    //                 pCgst: pCgst,
    //                 pTcs: pTcs,
    //                 pTcsRate: pTcsRate,
    //                 pOtherCharges: pOtherCharges == "" ? 0 : pOtherCharges,
    //                 pRoundOff: pRoundOff,
    //                 pTaxableVal: pTaxableVal,
    //                 pTotalAmount: pTotalAmount,
    //                 nTravellerCode: nTravellerCode,
    //                 //randomString: randomString,
    //                 spProductList: spProductList,
    //                 paymentData: paymentData,
    //                 prd_usd_rate: usdRate == "" ? 0 : usdRate,

    //                 radioType: radioType,
    //                 spLocation: spLocationValue,
    //                 //ppCorporate: ppCorporate,
    //                 spIndividual: spIndividual,
    //                 spSrnoTo: spSrnoTo,
    //                 spSrnoFrom: spSrnoFrom,
    //                 spFromDate: Common.dateYMD(spFromDate),
    //                 spToDate: Common.dateYMD(spToDate),
    //                 ppStateType: spStateType,
    //                 ppStateValue: spStateValue,
    //                 sourceOfFund: sourceOfFund,
    //                 sourceOfFundOther: sourceOfFundOther,
    //                 nRemark1: nRemark1,
    //                 nRemark2: nRemark2,
    //                 travellerPan: pan,
    //                 purpose: nPurposeId,
    //                 loan: reqLoanAvailed,
    //                 reqLoanAccountNo: reqLoanAvailed === "0" ? "" : reqLoanAccountNo,
    //                 reqLoanApplicant: reqLoanAvailed === "0" ? "" : reqLoanApplicant,
    //                 reqLoanApplicantPassport: reqLoanAvailed === "0" ? "" : reqLoanApplicantPassport,
    //                 reqLoanApplicantPan: reqLoanAvailed === "0" ? "" : reqLoanApplicantPan,
    //                 reqLoanCoApplicant: reqLoanAvailed === "0" ? "" : reqLoanCoApplicant,
    //                 reqLoanCoApplicantPassport: reqLoanAvailed === "0" ? "" : reqLoanCoApplicantPassport,
    //                 reqLoanCoApplicantPan: reqLoanAvailed === "0" ? "" : reqLoanCoApplicantPan,
    //                 reqLoanDisbRefNo: reqLoanAvailed === "0" ? "" : reqLoanDisbRefNo,
    //                 reqLoanDisbDate: Common.dateYMD(reqLoanDisbDate),
    //                 reqLoanDisbAmt: reqLoanDisbAmt === "" || reqLoanAvailed === "0" ? 0 : reqLoanDisbAmt,
    //                 reqLoanInstName: reqLoanAvailed === "0" ? "" : reqLoanInstName,
    //                 panRelationshipCode: panRelationShipCode,
    //                 pan: pan,
    //                 panName: panName,
    //                 nDob: Common.dateYMD(nDob),
    //                 nManualno: nManualno,
    //                 issavecorpindividualrisk: issavecorpindividualrisk,
    //                 riskValue: riskValue,
    //                 riskRemark: acRemark,
    //                 pTcsTaxable: pTcsTaxable,
    //                 pSelfDeclaration: pSelfDeclaration === "" ? 0 : pSelfDeclaration,
    //                 empType: empType,
    //                 cntIssue: cntIssue,
    //                 travellerCnt: travellerCnt,
    //                 agentGroup: agentGroup || 0,
    //                 agentAccount: agentAccount || 0,
    //                 pdCommission: pdCommission || 0,
    //                 pdCommisionOnOtherCharges: pdCommisionOnOtherCharges || '',

    //             fillViewCompareObject(resp);
    //             $(".loader").hide();
    //             setScrMode("Q");
    //             setSPSaleType(resp.saletype);
    //             setNTraveller({ id: resp.ind_id, label: resp.ind_label, desc: resp.desc });
    //             setNTravellerSrno(resp.individual_srno);
    //             if (resp.executive == null) setNExecutive(null);
    //             else setNExecutive({ id: resp.executive, label: resp.executive_name });
    //             setNMode(resp.mode);
    //             setNPurpose({ id: resp.purpose, label: resp.purpose_name });
    //             setNServiceType(resp.service_type);
    //             setNCountry({ id: resp.cntsrno, label: resp.cntname });
    //             setNResident(resp.residential);
    //             if (resp.corp_id == null) {
    //                 setNCorporate(null);
    //                 setCorpServiceCharge(0);
    //             } else {
    //                 setNCorporate({ id: resp.corp_id, label: resp.corp_label });
    //                 setCorpServiceCharge(resp.corp_id.split("^")[8]);
    //             }
    //             setNTravellerCode(resp.emp_code);
    //             setNState({ value: resp.state, label: resp.statename });
    //             setNPanForm60(resp.panform60);
    //             setNTicketClass(resp.ticketclass);
    //             setNFlightNo(resp.flightno);
    //             setNTicketNo(resp.ticketno);
    //             setNDepDate(new Date(resp.depdate));
    //             setNDuration(resp.duration)
    //             setNVisaType(resp.visatype);
    //             setNRemark1(resp.remark1);
    //             setNRemark2(resp.remark2);

    //             setPForexTotal(resp.forextotal);
    //             setPCgst(resp.cgst);
    //             setPSgst(resp.sgst);
    //             setPIgst(resp.igst);
    //             setPUgst(resp.ugst);
    //             setPRoundOff(resp.round_off);
    //             setPTotalAmount(resp.total_inr);
    //             setPOtherCharges(resp.other_charge);
    //             setPTaxableVal(resp.taxablevalue);

    //             setSPProductList(resp.productlist);
    //             setPaymentData(resp.paydetails);
    //             setPaymentLineNo(resp.paymaxlineno);
    //             setProductLineNo(resp.maxlineno);

    //             setHdrDate(resp.date);
    //             setHdrLocation(resp.locname);
    //             setHdrSrno(resp.srno);
    //             setTravellerSelected(0);
    //             setTravellerPan(resp.ind_pan);

    //             setHdrDateYmd(resp.dateymd);
    //             setIsIrnApplicable(resp.is_irn_applicable);

    //             setIsIrnGenerated(resp.isIrnGenerated);
    //             setIsIrnCancelled(resp.isIrnCancelled);
    //             setIrnCancelDate(resp.irncanceldt);
    //             setIrnCancelRemarkHdr(resp.irncancelrmk);
    //             setSourceOfFund({ id: resp.sourceoffundCode, label: resp.sourceoffund });
    //             setPanRelationship({ id: resp.panrelationid, label: resp.panrelationlabel });
    //             setPanRelationshipCode(resp.panrelationid.split("^")[1])
    //             setPan(resp.pan);
    //             setPanName(resp.panname);
    //             setNVisaType({ id: resp.visatypeCode, label: resp.visatype });

    //             setReqLoanAvailed(resp.isloanavailed);
    //             setReqLoanAccountNo(resp.loanAccountNo);
    //             setReqLoanApplicant(resp.loanApplicant);
    //             setReqLoanApplicantPassport(resp.loanApplicantPassport);
    //             setReqLoanApplicantPan(resp.loanApplicantPan);
    //             setReqLoanCoApplicant(resp.loanCoApplicant);
    //             setReqLoanCoApplicantPassport(resp.loanCoApplicantPassport);
    //             setReqLoanCoApplicantPan(resp.loanCoApplicantPan);
    //             setReqLoanDisbRefNo(resp.loanDisbRefno);
    //             if (resp.loanDisbDate == null) setReqLoanDisbDate(null);
    //             else setReqLoanDisbDate(new Date(resp.loanDisbDate));
    //             setReqLoanDisbAmt(resp.loanDisbAmt);
    //             setReqLoanInstName(resp.loanInstName);
    //             setNDob(new Date(resp.dob));

    //             setTravellerCnt(resp.individual_cnt);
    //             setPTcs(resp.tcsamt);
    //             setPTcsRate(resp.tcsrate);
    //             setPTcsTaxable(resp.tcstaxable);
    //             setPSelfDeclaration(resp.selfdeclaration);
    //             setCancelButtonView(resp.hdr_cancel_billYN === "1" ? false : true);
    //             //setSPNewDate(new Date(resp.dateymd))
    //             if (resp.manualid == null) setNManualno(null);
    //             else setNManualno({ id: resp.manualid, label: resp.manuallabel });
    //             setEmpType(resp.emp_type);
    //             setSourceOfFundValue(resp.sourceoffundCode.split('^')[2]);
    //             setSourceOfFundOther(resp.sourceOfFundOther);
    //             setIndividualName(resp.ind_id.split('^')[3]);
    //             setIndividualPan(resp.ind_id.split("^")[4]);
    //             setIndividualAddress(resp.ind_id.split("^")[9]);

    //             setPdCommisionOnOtherCharges(resp.hdr_oth_commission_yes_no);
    //             setPdAgent({ id: resp.oth_agent_id, label: resp.oth_agent_label });
    //             setPdCommission(resp.hdr_oth_commission_bank_charges);
    //             setAgentGroup(resp.hdr_oth_commission_agent_group);
    //             setAgentAccount(resp.hdr_oth_commission_agent_account);
    //             setNEncashmentNumber(resp.hdr_encashment_no);
    //             setNEncashmentFrom(resp.hdr_encashed_by);
    //             if (resp.hdr_encashment_date == null) setNEncashmentDate(null);
    //             else setNEncashmentDate(new Date(resp.hdr_encashment_date));
    //             if (resp.isIrnGenerated === "1") {
    //                 setIrnObj({
    //                     irn: resp.irn,
    //                     ackdate: resp.ackdate,
    //                     acknum: resp.ackno,
    //                     signedqr: resp.signedqr
    //                 });
    //             }
    //             if (!(resp.irncancelreason == null || resp.irncancelreason == "")) {
    //                 setIrnCancelReasonHdr(Common.getIrnCancelReason.find(item => item.id == resp.irncancelreason).desc);
    //             }
    //         }
    //     });
    // }

    const saveHandler = () => {
        $(".loader").show();
        setSaveDialogOpen(false);
        console.log(headerList, compareObj)
        //stuck here 
        // const compareToWhomeObj = headerList.filter(item => item.prd_line_no === compareObj.prd_line_no);
        const compareToWhomeObj = [{ ...headerList, bd_first_name: headerList[0].bd_first_name + ' ' + headerList[0].bd_middle_name + ' ' + headerList[0].bd_last_name }]
        console.log(compareToWhomeObj)
        const infoObject = Common.compareArrays(compareToWhomeObj, [compareObj]);
        console.log(infoObject);

        const a = Common.addInfoToAuditTrail(tranAuditTrail, infoObject, filtertransaction, ppLocationValue)
        console.log(a);
        console.log(tranAuditTrail);
        saveData.nIndividual = individual;
        setTranAuditTrail(a);
        Common.callApi(Common.apiPpSpModification, [sid, "updateData", JSON.stringify(saveData), JSON.stringify(a)], function (result) {
            $(".loader").hide();
            let resp = JSON.parse(result);
            if (resp.status) {
                setHeaderList(resp.list);
                setMsgText("Success");
                setMsgBox(true);
                setEditbtnView(true);
                setTranAuditTrail([]);
                setSaveData(null);
                setCompareObj(null)
            } else {
                setMsgText(resp.msg);
                setMsgBox(true);
            }

        });
    };

    const handleEditRequest = () => {
        setEditbtnView(false);
    };


    const saveBtnHandler = (item) => {
        let remark = "Transaction Modify";
        console.log(item);
        const indiVal = individual.id.split('^');
        var obj = {
            location: item.hdr_type,
            transaction: item.hdr_type,
            filterSrno: item.hdr_srno,
            modificationType: radioType,
            hdr_srno: item.hdr_srno,
            hdr_type: item.hdr_type,
            hdr_location: item.hdr_location,
            hdr_individual: indiVal[1],
            hdr_individual_id: indiVal[2],
            // ...item,
        }
        const updatedObj = {
            ...item,
        };

        if (radioType === 'INDIVIDUALPROFILE') {
            remark = `INDIVIDUAL Change from ${item?.hdr_individual + ' ' + item?.bd_first_name + ' ' + item?.bd_middle_name + ' ' + item?.bd_last_name} to ${individual.label} . `;
            updatedObj.hdr_individual = indiVal[1];
            updatedObj.hdr_individual_id = indiVal[2];
            updatedObj.bd_first_name = indiVal[3];
        }
        console.log(remark);
        updatedObj.remark = remark;
        obj.remark = remark;
        setCompareObj(updatedObj);
        setSaveData(obj)
        setSaveDialogOpen(true);
    }
    const btnActivityLog = (item) => {
        setShowActivityLog(true);
        setLogObject({ trantype: item.hdr_type, trannumber: item.hdr_srno, trancategory: "T", location: item.hdr_location, subtranno: item.prd_line_no || 0 });
    }

    const handleRadioChange = (value) => {
        setRadioType(value);
    }


    const handleBack = (e) => {
        setShowFilter(true);
        setScrMode('')
    }

    const handleNewIndiviualChange = (value) => {
        var id = value.id.split("^");
        setIndividual(value);
        setIndividualCode(id[1]);
    }



    return (
        <>
            <LoginHeader />
            <Menu />
            <Container fluid>
                <Row>
                    <Col>
                        <h3>Individual Change Utility </h3>
                    </Col>
                </Row>
                {scrMode === '' ?
                    <>
                        <Row>
                            <Col className='col-md-3 col-6'>
                                <Form.Group>
                                    <Form.Label>Location<span className="colorThemeRed">*</span></Form.Label>
                                    <AsyncSelect
                                        cacheOptions={false}
                                        defaultOptions={false}
                                        value={ppLocation}
                                        getOptionLabel={e => e.label + ' '}
                                        getOptionValue={e => e.id}
                                        loadOptions={Picklist.fetchLocationAllowedPicklist}
                                        onInputChange={Picklist.handleInputChange}
                                        onChange={handleLocationChange}
                                        styles={{
                                            menuList: (base) => ({
                                                ...base,
                                                maxHeight: 300, // adjust height as needed to fit ~8 options
                                            }),
                                        }}
                                    >
                                    </AsyncSelect>
                                </Form.Group>
                            </Col>
                            <Col className="col-md-3 col-6">
                                <Form.Label>Transaction</Form.Label>
                                <Form.Select
                                    value={filtertransaction}
                                    onChange={(e) => {
                                        setFiltertransaction(e.target.value);
                                    }}>
                                    <option value="">Select</option>
                                    <option value="PP">PP</option>
                                    <option value="SP">SP</option>
                                </Form.Select>
                            </Col>
                            <Col >
                                <Form.Label>Modification</Form.Label>
                                <Form.Check
                                    checked={radioType === "INDIVIDUALPROFILE"}
                                    onChange={() => handleRadioChange("INDIVIDUALPROFILE")}
                                    type="radio"
                                    label="Individual Profile"
                                />
                            </Col>

                        </Row>
                        <Row>
                            <Col className='col-md-3 col-6'>
                                <Form.Group>
                                    <Form.Label>SrNo<span className="colorThemeRed">*</span></Form.Label>
                                    <Form.Control type='text' maxLength={10} value={filterSrno} onChange={e => Common.validateNumValue(e.target.value, setFilterSrno)} />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>&nbsp;</Row>

                        <Row>
                            <Col >
                                <Button style={{ marginRight: '10px' }} variant="outline-primary" className="buttonStyle" size="sm" onClick={applyFilter}> List</Button>
                            </Col>
                            <Col></Col>
                        </Row>
                        <Row>&nbsp;</Row>
                    </>
                    :
                    scrMode === 'L' ? <>
                        <Row>
                            <Col >
                                <Button style={{ marginRight: '10px' }} variant="outline-primary" className="buttonStyle" size="sm" onClick={handleBack}> Back</Button>
                            </Col>
                            <Col></Col>
                        </Row>
                        <Row>
                            <Table responsive bordered striped>
                                <thead>
                                    <tr>
                                        <th>Srno</th>
                                        <th>Type</th>
                                        <th>Date</th>
                                        <th>Location</th>
                                        <th>Individual</th>
                                        <th>Corporate/Dealer</th>
                                        <th>Amount</th>
                                        <th>&nbsp;</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {headerList.map((item, index) => (
                                        <React.Fragment key={index}>
                                            {/* Product Row */}
                                            <tr>
                                                <td>{item.hdr_srno}</td>
                                                <td>{item.hdr_type}</td>
                                                <td>{item.hdr_date}</td>
                                                <td>{item.hdr_location + ' ' + item.entity_name}</td>
                                                <td>{item.hdr_individual + ' ' + item.bd_first_name + ' ' + item.bd_middle_name + ' ' + item.bd_last_name}</td>
                                                <td>{item.hdr_group != 0 ? (item.hdr_group + ' ' + item.hdr_ledger + ' ' + item.mvli_ledger_name) : ''}</td>
                                                <td>{item.hdr_total_inr}</td>


                                            </tr>

                                            {/* Commission Row with Editable Fields */}
                                            <tr>
                                                <td colSpan="13" >
                                                    <Table responsive bordered striped style={{ width: '100%' }}>
                                                        <tbody>
                                                            <tr>
                                                                {radioType === "INDIVIDUALPROFILE" &&
                                                                    <td className="col-md-9 col-6">
                                                                        <Col className="col-md-9 col-6">
                                                                            <Form.Group>
                                                                                <Form.Label>Individual Profile<span className="colorThemeRed">*</span>

                                                                                </Form.Label>
                                                                                <AsyncSelect
                                                                                    cacheOptions={false}
                                                                                    defaultOptions={false}
                                                                                    value={individual}
                                                                                    getOptionLabel={e => e.label + ' '}
                                                                                    getOptionValue={e => e.id}
                                                                                    loadOptions={Picklist.fetchIndividualPicklist}
                                                                                    onInputChange={Picklist.handleInputChange}
                                                                                    onChange={handleNewIndiviualChange}
                                                                                    formatOptionLabel={Picklist.formatOptionLabel}
                                                                                    components={{ Menu: Picklist.menu }}
                                                                                    isDisabled={editbtnView}
                                                                                    menuPortalTarget={document.body}
                                                                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                                                >
                                                                                </AsyncSelect>
                                                                            </Form.Group>
                                                                        </Col>
                                                                    </td>
                                                                }
                                                                <td className='col-md-3 col-6'>
                                                                    {(userRight.edit === "1" && !editbtnView) ?
                                                                        <Button style={{ marginRight: '10px' }} variant="outline-primary" className="buttonStyle" size="sm" onClick={() => saveBtnHandler(item)}>Save</Button>
                                                                        : null}
                                                                    {(userRight.edit === "1" && editbtnView) ?
                                                                        <Button style={{ marginRight: '10px' }} variant="outline-primary" className="buttonStyle" size="sm" onClick={() => handleEditRequest()}>Edit</Button>
                                                                        : null} &nbsp;
                                                                    <span>
                                                                        <Badge bg="secondary" className="handCursor" onClick={() => btnActivityLog(item)}>Activity Log</Badge>
                                                                    </span>
                                                                </td>

                                                            </tr>
                                                        </tbody>
                                                    </Table>
                                                </td>
                                            </tr>
                                        </React.Fragment>
                                    ))}
                                </tbody>
                            </Table>


                        </Row>

                    </> :
                        <></>

                }
            </Container >
            <ActivityLog logObject={logObject} show={showActivityLog} onHide={() => setShowActivityLog(false)} />
            <DialogYesNo isOpen={isSaveDialogOpen} onYes={(e) => saveHandler()} onNo={(e) => setSaveDialogOpen(false)}>
                {saveMsgTextYN}
            </DialogYesNo>
            <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                {msgText}
            </Dialog>

        </>
    )
}

export default SpPpModification;

